import React, { useState, useContext, useEffect } from "react";
import { user, client, session, socket } from "../../../utils/nakama";
import { Button, Row, Col, Image, Toast, ToastContainer, Form } from "react-bootstrap";
import closeBtn from '../images/close.png';
import "../lobby.css";
import eventsCenter, { PHASER_EVENTS }  from "../../../utils/phaserEvents";

export default function PlayerChat(props) {
    const [opponentId, setOpponentId] = useState('');
    const [gameData, setGameData] = useState(props.gameData);
    const [currChannel, setCurrChannel] = useState();
    const [currentMessage, setCurrentMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [nextCursor, setNextCursor] = useState();
    // const { universalChat, setUniversalChat } = useContext(FriendContext);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const resetLastSeenTime = () => {
        //Ask Ryan about this
        let obj = window.localStorage.getItem(`${gameData.player.userId}-chatData`);
        obj = JSON.parse(obj);
        // let uniChat = universalChat;
    
        let time = Date.now();
    
        if (obj[gameData.opponent.userId]) {
          obj[gameData.opponent.userId].last_opened_timeStamp = time;
        }
        //uniChat[props.friend.user.id].last_opened_timeStamp = time;
    
        window.localStorage.setItem(`${gameData.player.userId}-chatData`, JSON.stringify(obj));
        // setUniversalChat(uniChat);
    };

    const getChatHistory = async (channelId) => {
        try {
            const res = await client.listChannelMessages(session, channelId, 50, false);
            setMessages(res.messages);
            if (res.next_cursor) {
                setNextCursor(res.next_cursor);
            } else {
                setNextCursor(null);
            }
        } catch (error) {
            console.error("Error getting chat history:", error);
        }
    }

    const initChat = async (friendId) => {
        setOpponentId(friendId);
        const persistence = true;
        const hidden = false;
        try {
            const res = await socket.joinChat(friendId, 2, persistence, hidden);
            setCurrChannel(res.id);
            getChatHistory(res.id);
        } catch (error) {
            console.error("Error Joining direct channel:", error);
        }
    }

    const sendMessage = async () => {
        //console.log("Sending message:", currentMessage);
        if (currentMessage.length != 0) {
          const channelId = currChannel;
          const data = { chat: currentMessage };
       // console.log("Sending message:", channelId, data);
          setCurrentMessage('');
          try {
            await socket.writeChatMessage(channelId, data);
          } catch (err) {
            console.log(err);
          }
        }
    };

    useEffect(() => {
        //get the user id and chat history
        const opponentId = props.gameData.opponent.userId;
        initChat(opponentId);
       // resetLastSeenTime();
        return () => {
            //console.log("PlayerChat unmounted");
        }
    }, []);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && e.shiftKey == false) {
          e.preventDefault();
          sendMessage();
        }
    };

    const handleCloseInside = async () => {
        //console.log("Closing chat");
        // await nakama.socket.leaveChat(currChannel);
        props.togglePlayerChat();
    };

    useEffect(() => {
        // Only set the socket handler if socket is available
        if (socket) {
            socket.onchannelmessage = (message) => {
        //console.log("Socket -> Channel Message:", message);
        if(!props.playerChatOpen){ //if chat is Not open , then send phaser notification to flip the chat icon
            //send phaser notification
            //console.log("Sending phaser notification");
            eventsCenter.emit(PHASER_EVENTS.CHAT_NOTIFICATION, message);
        }
        // if (
        //   props.friend.user.id == message.user_id_one ||
        //   props.friend.user.id == message.user_id_two
        // ) {
           setMessages([message, ...messages]);
        //   let obj = universalChat;
        //   obj[props.friend.user.id].messages = [message, ...messages];
        //   setUniversalChat(obj);
        // } else {
        //   let id1 = message.user_id_one;
        //   let id2 = message.user_id_two;
        //   let id;
    
        //   if (id1 == props.user.id) {
        //     id = id2;
        //   } else {
        //     id = id1;
        //   }
    
        //   let obj = universalChat;
        //   obj[id].messages = [message, ...obj[id].messages];
        //   setUniversalChat(obj);
        // }
    
        // props.chatNotification(message);
            };
        }
    }, [socket]);

    const handleContainerScroll = async (e) => {
        //This is to retrieve more messages when the user scrolls to the top of the chat
        //The number 0.9 means that this triggers when the person scrolls 90% of the way to the top
    
        const top =
          0 - e?.target?.scrollTop >= 0.9 * (e?.target?.scrollHeight - e?.target?.offsetHeight);
    
        if (top && nextCursor && !loading) {
          try {
            setLoading(true);
            const nextResult = await client.listChannelMessages(
              session,
              currChannel,
              50,
              false,
              nextCursor
            );
            console.log("more chat logs -> Next Result:", nextResult);
    
            if (nextResult.next_cursor) {
              setNextCursor(nextResult.next_cursor);
    
             // let obj = universalChat;
             // obj[props.friend.user.id].next_cursor = nextResult.next_cursor;
              //setUniversalChat(obj);
            } else {
              setNextCursor(null);
    
             // let obj = universalChat;
             // obj[props.friend.user.id].next_cursor = null;
              //setUniversalChat(obj);
            }
    
            setMessages([...messages, ...nextResult.messages]);
    
           // let obj = universalChat;
           // obj[props.friend.user.id].messages = [...messages, ...nextResult.messages];
            //setUniversalChat(obj);
            setLoading(false);
          } catch (err) {
            console.log("Error listing channel messages:",err);
          }
        }
      };

    return (
        <>
            <div style={{position : "relative"}}>
                <div className="chat-name-header" style={{color: "#ffffff", fontSize: "3rem"}}>
                    {gameData.opponent.username}
                    <img src={closeBtn} className="chat-name-header-close" onClick={props.togglePlayerChat} alt="Close icon" />
                </div>
                <div
                    className="chat-drawer-containter"
                    id="chat-drawer-container"
                    onScroll={handleContainerScroll}
                >
                {messages.length > 0 ? (
                messages.map((message, index) => {
                    const stamp = new Date(message.create_time);
                    const prevStamp = new Date(messages[index - 1]?.create_time);
                    const date = prevStamp.getUTCDate();
                    const day = prevStamp.getUTCDay();
                    const month = prevStamp.getUTCMonth();
                    const time =
                    prevStamp.getUTCHours() >= 12
                        ? `${prevStamp.getUTCHours() - 12}:${
                            prevStamp.getUTCMinutes() < 10
                            ? `0${prevStamp.getUTCMinutes()}`
                            : prevStamp.getUTCMinutes()
                        } PM`
                        : `${prevStamp.getUTCHours()}:${
                            prevStamp.getUTCMinutes() < 10
                            ? `0${prevStamp.getUTCMinutes()}`
                            : prevStamp.getUTCMinutes()
                        } AM`;
                    const messageWithBr = message.content.chat.replace(/\n/g, '<br />');
                    const sanitizedMessage = messageWithBr.replace(/<(?!br\s*\/?)[^>]+>/g, '');

                    return (
                    <div key={index} className="chat-message-content-box">
                        {index == messages.length - 1 && messages.length > 1 ? (
                        <div className="chat-message-content-time">
                            <div>{`${days[day]}, ${months[month]} ${date} ${time}`}</div>
                        </div>
                        ) : (
                        <></>
                        )}
                        <div
                        className={
                            message.sender_id !== opponentId ? 'chat-message-user' : 'chat-message-friend'
                        }
                        >
                        <div
                            className="chat-message-content"
                            dangerouslySetInnerHTML={{
                            __html: sanitizedMessage,
                            }}
                        ></div>
                        </div>
                        {stamp.getUTCDate() != date && index != 0 ? (
                        <div className="chat-message-content-time">
                            {stamp.getUTCDate() != date ? (
                            <div>{`${days[day]}, ${months[month]} ${date} ${time}`}</div>
                            ) : (
                            <></>
                            )}
                        </div>
                        ) : (
                        <></>
                        )}
                    </div>
                    );
                })
                ) : (
                    <div style={{color: "#ffffff", fontSize: "2rem"}}>No Chat History</div>
                )}
                </div>
                <div className="chat-form" style={{position : "absolute", bottom : 0, left : 0}}>
                    <Form.Group className="" controlId="exampleForm.ControlTextarea1" style={{width : "100%"}}>
                        <Form.Control
                            type="text"
                            size="lg"
                            maxLength={40}
                            placeholder="Enter message to send"
                            value={currentMessage}
                            onChange={(e) => setCurrentMessage(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                    </Form.Group>
                    <Button variant="primary" size="lg" onClick={sendMessage}>
                        Send
                    </Button>
                </div>
            </div>
        </>
    );
}